module.exports = __webpack_public_path__ + "static/img/10.e6cca75.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/15/eng/10.png
// module id = /RwU
// module chunks = 0